import { render, staticRenderFns } from "./production.vue?vue&type=template&id=d56c1c06&scoped=true"
import script from "./production.vue?vue&type=script&lang=js"
export * from "./production.vue?vue&type=script&lang=js"
import style0 from "./production.vue?vue&type=style&index=0&id=d56c1c06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56c1c06",
  null
  
)

export default component.exports